// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reviews-top-VZdm8::before {
    top: 11px;
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/Reviews/Reviews.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb","sourcesContent":[".top::before {\n    top: 11px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"top": `Reviews-top-VZdm8`
};
module.exports = ___CSS_LOADER_EXPORT___;
